// extracted by mini-css-extract-plugin
export default {"container":"design-seek-item-background-container-module__container--ZTCCY"};